// TX-readiness helpers for shortform media (promo / filler / tvc / gfx / movies).
// "Ready" = a usable TX file path exists (storage_path is non-empty).
//
// Note: transcoded_file_path lives on EPISODES, not MEDIA — episodes have
// stitch + transcode pipeline outputs as separate columns. Shortform media
// has a single storage_path that is the TX file directly (or the transcode
// pipeline writes back to storage_path on completion).
//
// Approval and SMB staging state are intentionally NOT part of this gate —
// operators schedule promos days/weeks in advance and approve later, so a
// stricter "approved AND staged" rule would show red on most legitimate rows.
// The dot answers "is there content to play"; approval/staging are surfaced
// elsewhere (EditMedia, status badges).

export function isMediaTxReady (media) {
  if (!media) return false
  return !!(media.storage_path?.trim())
}

export function mediaStatusDot (media) {
  return isMediaTxReady(media) ? '🟢' : '🔴'
}
